export enum SysConsts {
  MAX_RETRY_ATTEMPTS = 3,
  RETRY_DELAY = 5000,
  SYNC_INTERVAL = 1000 * 60 * 5,
  UPDATE_INTERVAL = 1000,
}
